<template>
  <section class="hero is-light is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img src="../assets/forgetpass.png">
          </div>
          <div class="column">
            <form @submit.prevent="newpassSubmit" class="formforget">
              <div class="heading">
                <h1 class="title">
                  Toolindo
                </h1>
                <h2 class="subtitle">
                  Change Password
                </h2>
              </div>
              <b-field label="Username">
                <b-input
                  type="text"
                  v-model="user"
                  placeholder="Your username"
                  required>
                </b-input>
              </b-field>
              <b-field label="Password">
                <b-input
                  type="password"
                  v-model="password"
                  password-reveal
                  placeholder="Old password"
                  maxlength="16"
                  required>
                </b-input>
              </b-field>
              <b-field label="New Password">
                <b-input
                  type="password"
                  v-model="newpassword"
                  password-reveal
                  placeholder="New password"
                  minlength="4"
                  maxlength="16"
                  required>
                </b-input>
              </b-field>
              <b-field label="Confirm Password"
                :message="retypemessage"
                :type="retypetype">
                <b-input
                  type="password"
                  v-model="retypepassword"
                  password-reveal
                  placeholder="Confirm password"
                  minlength="4"
                  maxlength="16"
                  @input="checkNew"
                  required>
                </b-input>
              </b-field>
              <div class="buttons">
                <button class="button is-success" type="submit"
                  :loading="loggingIn">Save Password</button>
                <button class="button" type="button" @click="cancel">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'forget',
  data() {
    return {
      user: '',
      password: '',
      newpassword: '',
      retypepassword: '',
      retypemessage: '',
      retypetype: '',
    };
  },
  computed: {
    ...mapState([
      'loggingIn',
      'loginError',
    ]),
  },
  methods: {
    ...mapActions([
      'changePass',
    ]),
    newpassSubmit() {
      const payload = { user: this.user, old: this.password, new: this.newpassword };
      this.changePass(payload).then((res) => {
        if (res === 'success') {
          this.$router.push('/');
        }
      }, (e) => {
        this.$dialog.alert(e);
      });
    },
    checkNew() {
      if (this.newpassword !== this.retypepassword) {
        this.retypetype = 'is-danger';
        this.retypemessage = 'password not same';
      } else {
        this.retypetype = '';
        this.retypemessage = '';
      }
    },
    cancel() {
      this.user = '';
      this.password = '';
      this.newpassword = '';
      this.retypepassword = '';
      this.retypemessage = '';
      this.retypetype = '';
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss" scoped>
.formforget {
  text-align: left;
  padding: 0rem 10rem;
}
</style>
